var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "filter_panel" }, [
    _c(
      "div",
      { staticClass: "filter_panel_doughnut_wrapper" },
      [
        !_vm.isLoading
          ? _c("div", {
              staticClass: "filter_panel_doughnut",
              attrs: { id: _vm.doughnutChartElementId },
            })
          : _vm._e(),
        _vm.isLoading
          ? _c("pui-loader-spinner", {
              attrs: { title: `${_vm.$t("eventSubmittingModal.text")}...` },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm.filtersOptionsProvider
      ? _c(
          "div",
          { staticClass: "filter_panel_form" },
          [
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: 12,
                    expression: "12",
                  },
                ],
                attrs: { label: _vm.$t("operationalData.filters.periodStart") },
              },
              [
                _c(
                  "pui-date-picker",
                  {
                    staticClass: "filter_panel__form__row--datepicker",
                    attrs: {
                      show: _vm.startCalendar,
                      "use-input": true,
                      "use-calendar": true,
                      "use-checkbox": true,
                      "is-range": false,
                      "months-only": true,
                      "days-only": true,
                      start: _vm.activeFilters.startDate,
                    },
                    on: {
                      "update:start": function ($event) {
                        return _vm.$set(_vm.activeFilters, "startDate", $event)
                      },
                      reset: _vm.onStartDateReset,
                      apply: function ($event) {
                        _vm.startCalendar = false
                      },
                      "update:end": _vm.onDatePickerFilterChange,
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.activeFilters.startDate,
                          expression: "activeFilters.startDate",
                        },
                      ],
                      staticClass:
                        "pui-form-input-field filter_panel__form__row--datepicker--input",
                      attrs: {
                        type: "month",
                        placeholder: "",
                        disabled: _vm.isTableLoading,
                      },
                      domProps: { value: _vm.activeFilters.startDate },
                      on: {
                        click: function ($event) {
                          _vm.startCalendar = !_vm.startCalendar
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.activeFilters,
                            "startDate",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: 12,
                    expression: "12",
                  },
                ],
                attrs: { label: _vm.$t("operationalData.filters.periodEnd") },
              },
              [
                _c(
                  "pui-date-picker",
                  {
                    staticClass: "filter_panel__form__row--datepicker",
                    attrs: {
                      show: _vm.endCalendar,
                      "use-calendar": true,
                      "use-input": true,
                      "use-checkbox": true,
                      "is-range": false,
                      "days-only": true,
                      "months-only": true,
                      start: _vm.activeFilters.endDate,
                    },
                    on: {
                      "update:start": function ($event) {
                        return _vm.$set(_vm.activeFilters, "endDate", $event)
                      },
                      reset: _vm.onEndDateReset,
                      apply: function ($event) {
                        _vm.endCalendar = false
                      },
                      "update:end": _vm.onDatePickerFilterChange,
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.activeFilters.endDate,
                          expression: "activeFilters.endDate",
                        },
                      ],
                      staticClass:
                        "pui-form-input-field filter_panel__form__row--datepicker--input",
                      attrs: {
                        type: "month",
                        placeholder: "",
                        disabled: _vm.isTableLoading,
                      },
                      domProps: { value: _vm.activeFilters.endDate },
                      on: {
                        click: function ($event) {
                          _vm.endCalendar = !_vm.endCalendar
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.activeFilters,
                            "endDate",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: 12,
                    expression: "12",
                  },
                ],
                attrs: { label: _vm.$t("country") },
              },
              [
                _c("pui-form-multi-select", {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: 12,
                      expression: "12",
                    },
                  ],
                  key: _vm.countryOptionsRefreshKey,
                  attrs: {
                    id: _vm.multiselectIds.get("country"),
                    "search-input-placeholder": _vm.$t("placeholder"),
                    label: _vm.$t("country"),
                    options: _vm.filtersOptionsProvider.countries,
                    "is-disabled": _vm.isTableLoading,
                  },
                  on: { change: _vm.onFilterChange },
                  model: {
                    value: _vm.activeFilters.countries,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeFilters, "countries", $$v)
                    },
                    expression: "activeFilters.countries",
                  },
                }),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: 12,
                    expression: "12",
                  },
                ],
                attrs: { label: _vm.$t("site") },
              },
              [
                _c("pui-form-multi-select", {
                  attrs: {
                    id: _vm.multiselectIds.get("site"),
                    "search-input-placeholder": _vm.$t("placeholder"),
                    label: _vm.$t("site"),
                    options: _vm.filtersOptionsProvider.sites,
                    "is-disabled": _vm.isTableLoading,
                  },
                  on: { change: _vm.onFilterChange },
                  model: {
                    value: _vm.activeFilters.sites,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeFilters, "sites", $$v)
                    },
                    expression: "activeFilters.sites",
                  },
                }),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: 12,
                    expression: "12",
                  },
                ],
                attrs: { label: _vm.$t("unit") },
              },
              [
                _c("pui-form-multi-select", {
                  attrs: {
                    id: _vm.multiselectIds.get("unit"),
                    "search-input-placeholder": _vm.$t("placeholder"),
                    label: _vm.$t("unit"),
                    options: _vm.filtersOptionsProvider.units,
                    "is-disabled": _vm.isTableLoading,
                  },
                  on: { change: _vm.onFilterChange },
                  model: {
                    value: _vm.activeFilters.units,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeFilters, "units", $$v)
                    },
                    expression: "activeFilters.units",
                  },
                }),
              ],
              1
            ),
            _c(
              "pui-form-group",
              { attrs: { label: _vm.$t("status") } },
              [
                _c("pui-form-multi-select", {
                  key: _vm.statusesDropdownRefreshKey,
                  staticStyle: { "margin-bottom": "25px" },
                  attrs: {
                    id: _vm.multiselectIds.get("status"),
                    "search-input-placeholder": _vm.$t("placeholder"),
                    label: _vm.$t("status"),
                    options: _vm.filtersOptionsProvider.statuses,
                    "is-disabled": _vm.isTableLoading,
                  },
                  on: { change: _vm.onFilterChange },
                  model: {
                    value: _vm.activeFilters.statuses,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeFilters, "statuses", $$v)
                    },
                    expression: "activeFilters.statuses",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.filtersOptionsProvider
      ? _c(
          "div",
          { staticClass: "filter_panel_persistent_btn" },
          [
            _c(
              "pui-button",
              {
                staticClass: "filter_panel_clear_btn",
                attrs: { disabled: _vm.isTableLoading || _vm.isFilterEmpty },
                on: { click: _vm.onClearFilters },
              },
              [_vm._v(" " + _vm._s(_vm.$t("clearFilters")) + " ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }